module.exports = __webpack_public_path__ + "media/loadervideo.af83a2a3.mp4";